import React, { useCallback, useMemo } from 'react';
import { createStyles, withStyles, Grid, Typography, Button, Box } from '@material-ui/core';
import { I18n } from 'src/translations/i18n';
import DropDownSelector from '../Inputs/DropDownSelector';
import TextInput from '../Inputs/TextInput';
const styles = (theme) => createStyles({
    text: {
        color: theme.palette.text.color
    },
    actionButton: {
        backgroundColor: theme.palette.sideBar.itemActive.background,
        color: theme.palette.sideBar.itemActive.color,
        fontWeight: 500,
        '&:hover': {
            backgroundColor: theme.palette.sideBar.itemActive.background
        }
    }
});
const MAX_COMMENT_LENGTH = 200;
function StartShiftForm({ classes, isJobSelected, showDepartments, selectedDepartment, departmentsOptions, onDepartmentSelect, showProjects, selectedProject, projectsOptions, onProjectSelect, comment, onCommentChange, onStartShift, disableShiftButton, enableComment }) {
    const commentLength = comment.length;
    const commentInputLabelWithCounter = useMemo(() => {
        const charsLeft = MAX_COMMENT_LENGTH - commentLength;
        return `${I18n.t('Comment')} (${charsLeft})`;
    }, [commentLength]);
    const isStartButtonDisabled = useMemo(() => {
        const conditionsAreMet = (!disableShiftButton
            && isJobSelected
            && (!showDepartments || selectedDepartment)
            && (!showProjects || selectedProject));
        return !conditionsAreMet;
    }, [disableShiftButton, isJobSelected, selectedDepartment, selectedProject, showDepartments, showProjects]);
    const commentChangeHandler = useCallback((newContent) => {
        if (newContent.length > MAX_COMMENT_LENGTH)
            return;
        onCommentChange(newContent);
    }, [onCommentChange]);
    return (React.createElement(Grid, { container: true, spacing: 1, direction: "column" },
        React.createElement(Grid, { item: true },
            React.createElement(Typography, { align: "center", variant: "h6", className: classes.text }, I18n.t('NoStartedJobs'))),
        showDepartments && (React.createElement(Grid, { item: true },
            React.createElement(DropDownSelector, { values: selectedDepartment ? [selectedDepartment] : [], onSelect: onDepartmentSelect, options: departmentsOptions, label: "Department", isSingleSelect: true, filterEnabled: true, buttonWidth: "100%", isRequired: true, disabled: !isJobSelected }))),
        showProjects && (React.createElement(Grid, { item: true },
            React.createElement(DropDownSelector, { values: selectedProject ? [selectedProject] : [], onSelect: onProjectSelect, options: projectsOptions, label: "Project", isSingleSelect: true, filterEnabled: true, buttonWidth: "100%", isRequired: true, disabled: !isJobSelected }))),
        React.createElement(Grid, { item: true },
            React.createElement(Box, { display: "flex", flexDirection: "column", py: 2 },
                React.createElement(Button, { className: classes.actionButton, fullWidth: true, size: "large", variant: "contained", onClick: onStartShift, disabled: isStartButtonDisabled }, I18n.t('StartShift')))),
        enableComment && (React.createElement(Grid, { item: true },
            React.createElement(TextInput
            // @ts-ignore
            , { 
                // @ts-ignore
                label: commentInputLabelWithCounter, placeholder: I18n.t('Comment'), type: "textarea", value: comment, onChange: commentChangeHandler, rows: 6, disabled: !isJobSelected, style: { resize: 'none' } })))));
}
export default withStyles(styles)(StartShiftForm);
